import React from "react";
import { Link } from "gatsby";

class EventCard extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    console.log("componentDidMount called ");
  }
  render() {
    return (
      <div className="event-card">
        <div className="event-card-inner" style={{ padding: '25px' }}>
          <div className="event-card-image">
            <div className="event-card-image-inner">
              <img src={this.props.data.EventImagePath} alt="" height="100px" width="100px" />
              <span>{this.props.data.StartDate}</span>
            </div>
          </div>
          <div className="event-card-content">
            <h3 style={{ fontSize: '20px' }}>
              <Link to={'/programs/national-program-details'}
                state={{ id: this.props.data.EventsId }} >{this.props.data.EventTitle}</Link>
            </h3>
            <ul className="event-card-list">
              <li>
                <i className="azino-icon-clock"></i>
                <strong>Time:</strong><br /> {this.props.data.TimeTxt}
              </li>
              <li>
                <i className="azino-icon-pin1"></i>
                <strong>Location:</strong><br /> {this.props.data.EventLocation}
              </li>
            </ul>
            <h3 style={{ float: 'right', fontSize: '14px', margin:'-30% -50% 0 0' }}>
              <br />
              <Link to={'/programs/national-program-details'}
                state={{ id: this.props.data.EventsId }}>More...</Link>
            </h3>
          </div>
        </div>
      </div>
    );
  }
}

export default EventCard;
